module.exports = __webpack_public_path__ + "static/media/Imagen 5.7aea42b9.jpg";